import { createContext } from 'react';
import type { CreateInput, ID, QuotePreset, UpdateInput } from '@/types';

export interface PresetContextValue {
  presets: QuotePreset[];
  isLoading: boolean;
  createPreset: (input: Omit<CreateInput<QuotePreset>, 'businessId'>) => Promise<QuotePreset>;
  updatePreset: (id: ID, patch: UpdateInput<QuotePreset>) => Promise<void>;
  deletePreset: (id: ID) => Promise<void>;
}

export const PresetContext = createContext<PresetContextValue | null>(null);
